var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoleandAccessManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.24111 6.47656C8.9175 6.47656 8.59852 6.60138 8.3535 6.8464C7.86347 7.33643 7.86809 8.14082 8.35812 8.63548C8.59852 8.87587 8.9175 9.01456 9.25497 9.01456H9.2596C9.59707 9.01456 9.89294 8.87587 10.1241 8.6401V8.63085C10.4015 8.39508 10.5032 8.0761 10.5032 7.73862C10.5032 7.40115 10.383 7.08217 10.1426 6.84177C9.89294 6.60138 9.56471 6.47656 9.24111 6.47656Z",
    fill: "#ACBED2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.88067 2.54262L7.24415 0.522393C6.98064 0.198787 6.58769 0 6.17163 0H1.40075C0.633343 0 0 0.642589 0 1.41V14.59C0 15.3528 0.633343 16 1.40075 16H1.61803V4.66455C1.61803 3.49032 2.59347 2.54262 3.76307 2.54262H8.88067Z",
    fill: "#ACBED2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.8304 3.28516H3.7628C3.00001 3.28516 2.35742 3.90463 2.35742 4.66742V15.9982H12.2413H17.8304C18.5932 15.9982 19.2312 15.3557 19.2312 14.5882V4.66742C19.2312 3.90463 18.5978 3.28516 17.8304 3.28516ZM13.9333 12.4201L12.87 13.4834C12.796 13.5573 12.7036 13.5897 12.6065 13.5897C12.514 13.5897 12.4169 13.5527 12.343 13.4834C12.1997 13.3401 12.1997 13.1043 12.343 12.961L13.1474 12.1566L12.6573 11.6665L11.9362 12.3924C11.8622 12.4663 11.7697 12.4987 11.6726 12.4987C11.5756 12.4987 11.4831 12.4617 11.4091 12.3924C11.2658 12.249 11.2658 12.0133 11.4091 11.87L12.1349 11.1488L10.3875 9.39669C10.0592 9.62321 9.66629 9.75265 9.25947 9.75265H9.25485C8.71859 9.75265 8.21931 9.53537 7.84023 9.15629C7.05895 8.37501 7.05433 7.09446 7.83561 6.31781C8.61688 5.54115 9.88357 5.54115 10.6695 6.32243C11.0486 6.70151 11.2566 7.20541 11.2612 7.73705C11.2612 8.14387 11.141 8.53219 10.9191 8.86042L12.8931 10.839C12.907 10.8483 12.9208 10.8622 12.9347 10.876C12.9486 10.8899 12.9578 10.9038 12.9717 10.9176L13.9425 11.8931C14.0766 12.041 14.0766 12.2768 13.9333 12.4201Z",
    fill: "#ACBED2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleandAccessManagement);
export default __webpack_public_path__ + "static/media/RoleandAccessManagement.99c7e244e48083a19d594cea6dde15ca.svg";
export { ForwardRef as ReactComponent };